import React from 'react';
import ContentContainer from '../components/ContentContainer';
import Section from '../components/Section';

export default ({ data }) => {
  const { markdownRemark: post } = data;
  return (
    <ContentContainer>
      <Section
        name='privacy'
      >
        <h2 className="title is-size-3 has-text-primary is-bold-light">{post.frontmatter.title}</h2>
        <div className="content" dangerouslySetInnerHTML={{ __html: post.html }} />
      </Section>
    </ContentContainer>
  );
};

export const aboutPageQuery = graphql`
  query PrivacyPage($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/privacy.js